import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='customer-privacy-notice'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h1'
          nextElement='link'
          align='center'>
          Customer Privacy Notices
        </Typography>
        <BulletedList
          bulletType='none'
          bulletedListData={[
            {
              bulletText: (
                <Link
                  id='customer-privacy-notice-nm-link'
                  variant='primaryDeemphasize'
                  linkUrl='#nm'>
                  The Northwestern Mutual Life Insurance Company
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id='customer-privacy-notice-nltc-link'
                  variant='primaryDeemphasize'
                  linkUrl='#nltc'>
                  Northwestern Long Term Care Insurance Company
                </Link>
              ),
            },
            {
              bulletText: (
                <Link
                  id='customer-privacy-notice-nmis-nwmc-link'
                  variant='primaryDeemphasize'
                  linkUrl='#nmisAndnmwmc'>
                  Northwestern Mutual Investment Services, LLC &#40;NMIS&#41; &#38; Northwestern Mutual Wealth Management Company (NMWMC)
                </Link>
              ),
            },
          ]}
        />
        <Typography
          id='nm'
          component='h2'
          nextElement='link'>
          The Northwestern Mutual Life Insurance Company
        </Typography>
        <Link
          id='customer-privacy-notice-printable-link'
          linkUrl='/assets/pdf/legal/nm-50-0142.pdf'
          isInternalPdf
          variant='primaryDeemphasize'
          ariaLabel='Printable Version: All States'>
          Printable Version: The Northwestern Mutual Life Insurance Company
        </Link>
        <Typography
          variant='h3'
          nextElement='typography'>
          Facts: What does The Northwestern Mutual Life Insurance Company &#40;Northwestern Mutual&#41; do with your
          personal information&#63;
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Why&#63;
        </Typography>
        <Typography nextElement='typography'>
          Financial companies choose how they share your personal information. Federal and state laws give consumers the
          right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share, and
          protect your personal information. Please read this notice carefully understand what we do.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          What&#63;
        </Typography>
        <Typography nextElement='typography'>
          The types of personal information we collect and share depend on interactions, product&#39;s
          or services you have with us. This information can include:
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            {
              bulletText: <>
                Personal information and identifiers:
                <em>
                  name, social security number, date of birth
                </em>
              </>,
            },
            {
              bulletText: <>
                Demographics: <em>age, disability status, citizenship, gender</em>
              </>,
            },
            {
              bulletText: <>
                Professional or employment information: <em>income, employment history</em>
              </>,
            },
            {
              bulletText: <>
                Education information: <em>school records, degree, academic achievements</em>
              </>,
            },
            {
              bulletText: <>Financial information: <em>bank accounts, investment or brokerage accounts, assets&#47;debts, account
                balances</em></>,
            },
            { bulletText: <>Medical information: <em>medical history, medical questionnaires</em></> },
            { bulletText: <>Biometric Information: <em>for information protection, fraud prevention, or authentication</em></> },
            { bulletText: <>Internet or network activity: <em>browser &#38; search history, interactions, IP address</em></> },
            {
              bulletText: <>Profile information: <em>profiles reflecting a person&#39;s preferences such as interests, hobbies,
                characteristic tendencies, behaviors, or attitudes</em></>,
            },
            { bulletText: <>Product information: <em>policy&#47;account number, policy&#47;account values</em></> },
            { bulletText: <>Audiovisual information: <em>video &#38; audio recordings</em></> },
          ]}
        />
        <Typography
          component='h3'
          nextElement='typography'>
          How&#63;
        </Typography>
        <Typography disableBottomPadding>
          All financial companies need to share customer personal information to run their everyday business. In the section
          below, we list the reasons financial companies can share their customer information&#59; the reasons Northwestern Mutual
          chooses to share&#59; and whether you can limit this sharing.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
